var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-close",on:{"click":function($event){return _vm.$emit('close-modal')}}},[_c('i',{staticClass:"far fa-times"})])}
var staticRenderFns = []

export { render, staticRenderFns }